var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtensivoR3CirurgiaGeral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 603.379,
    height: 159.463,
    viewBox: "0 0 603.379 159.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ffbd"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_140",
    x: 466.845,
    y: 95.134,
    width: 136.535,
    height: 63.462,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_142",
    x: 466.894,
    y: 0.559,
    width: 136.437,
    height: 120.08,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_309",
    x: 0,
    y: 0.917,
    width: 74.815,
    height: 89.565,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_310",
    x: 45.677,
    y: 0.917,
    width: 90.11,
    height: 89.565,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_311",
    x: 104.555,
    y: 0.917,
    width: 72.023,
    height: 89.565,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_312",
    x: 151.77,
    y: 0.917,
    width: 74.815,
    height: 89.565,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_313",
    x: 203.83,
    y: 0.917,
    width: 80.924,
    height: 89.565,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_314",
    x: 258.987,
    y: 0,
    width: 83.456,
    height: 91.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ret\\xE2ngulo_143",
    x: 319.424,
    y: 0.917,
    width: 48.284,
    height: 89.565,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_315",
    x: 343.196,
    y: 0.917,
    width: 86.445,
    height: 89.565,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_316",
    x: 400.852,
    y: 0.001,
    width: 86.684,
    height: 91.398,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_317",
    x: 0.092,
    y: 73.711,
    width: 76.581,
    height: 84.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_318",
    x: 51.691,
    y: 73.712,
    width: 81.99,
    height: 84.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_319",
    x: 108.74,
    y: 73.711,
    width: 78.873,
    height: 84.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_320",
    x: 165.577,
    y: 73.711,
    width: 78.833,
    height: 84.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_321",
    x: 217.306,
    y: 73.711,
    width: 103.008,
    height: 84.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_322",
    x: 291.883,
    y: 72.867,
    width: 82.252,
    height: 86.596,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_323",
    x: 351.256,
    y: 73.711,
    width: 78.873,
    height: 84.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Caminho_324",
    x: 408.093,
    y: 73.711,
    width: 79.517,
    height: 84.907,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "extensivoR3CirurgiaGeral",
    transform: "translate(-2263.811 -723.312)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Ret\\xE2ngulo_140)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_140-2",
    "data-name": "Ret\\xE2ngulo 140",
    width: 106.535,
    height: 33.462,
    transform: "translate(481.84 110.13)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Ret\\xE2ngulo_142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_142-2",
    "data-name": "Ret\\xE2ngulo 142",
    width: 106.437,
    height: 90.08,
    transform: "translate(481.89 15.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_309-2",
    "data-name": "Caminho 309",
    d: "M0,1.12V60.685H44.815V46.459H17.935V36.728H39.666V23.506H17.935v-8.64H44.815V1.12Z",
    transform: "translate(15 14.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_310)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_310-2",
    "data-name": "Caminho 310",
    d: "M113.2,1.12,95.886,28.749l20.062,31.935H94.672l-11-18.758-11.1,18.758H55.838L75.025,29.928,56.623,1.12H77.949l9.241,16.03L96.783,1.12Z",
    transform: "translate(4.84 14.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_311-2",
    "data-name": "Caminho 311",
    d: "M157.485,15.389v45.3H140.161v-45.3h-12.35V1.12h42.023V15.389Z",
    transform: "translate(-8.26 14.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_312-2",
    "data-name": "Caminho 312",
    d: "M230.345,46.459V60.685H185.53V1.12h44.815V14.866H203.464v8.64H225.2V36.728H203.464v9.731Z",
    transform: "translate(-18.76 14.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_313-2",
    "data-name": "Caminho 313",
    d: "M300.093,60.685h-14.88L268.9,34.367a100.232,100.232,0,0,1-6.335-12.3,41.441,41.441,0,0,1,1.441,9.775V60.685H249.169V1.12h17.28l13.878,21.816a84.116,84.116,0,0,1,6.283,11.435,86.6,86.6,0,0,1-1.4-15.622V1.12h14.88Z",
    transform: "translate(-30.34 14.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_314-2",
    "data-name": "Caminho 314",
    d: "M316.595,43.244l16.975-3.055q2.138,7.2,11,7.2,6.895,0,6.9-3.666a3.4,3.4,0,0,0-1.594-2.989,17.112,17.112,0,0,0-5.7-1.9q-15.668-3-20.117-7.847A16.291,16.291,0,0,1,319.606,19.6,17.83,17.83,0,0,1,326,5.587Q332.391,0,344.392,0q18.2,0,24.044,14.618L353.294,19.2q-2.356-5.978-9.556-5.979-5.979,0-5.978,3.71a2.934,2.934,0,0,0,1.352,2.574,16.53,16.53,0,0,0,5.238,1.742,110.8,110.8,0,0,1,15.189,4,16.373,16.373,0,0,1,7.5,5.953,16.649,16.649,0,0,1,3.009,9.934,17.6,17.6,0,0,1-7.331,14.651q-7.33,5.61-19.244,5.61-21.775,0-26.881-18.153",
    transform: "translate(-42.61 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Ret\\xE2ngulo_143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_143-2",
    "data-name": "Ret\\xE2ngulo 143",
    width: 18.284,
    height: 59.565,
    transform: "translate(334.42 15.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_315-2",
    "data-name": "Caminho 315",
    d: "M475.98,1.12,457.5,60.685H438.863L419.535,1.12H438.8l9.426,32.466q.964,2.88,1.711,5.672L460.947,1.12Z",
    transform: "translate(-61.34 14.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_316-2",
    "data-name": "Caminho 316",
    d: "M518.424,61.4q-12.568,0-20.488-8.335t-7.92-22.3q0-13.353,7.572-22.058T518.6,0q12.436,0,20.27,8.2T546.7,30.11q0,14.182-7.9,22.735T518.424,61.4m-.088-13.528a6.913,6.913,0,0,0,6.655-4.037q2.028-4.036,2.029-14.771,0-15.535-8.334-15.535-8.99,0-8.989,17.717,0,16.625,8.64,16.626",
    transform: "translate(-74.16 15)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_317-2",
    "data-name": "Caminho 317",
    d: "M46.694,90.106v54.907H29.839V123.654H16.968v21.359H.113V90.106H16.968V110.3H29.839V90.106Z",
    transform: "translate(14.98 -1.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_318-2",
    "data-name": "Caminho 318",
    d: "M97.981,145.014l-3.1-10.821H80.169l-3.3,10.821H63.189L80.14,90.107H97.959l17.221,54.907ZM83.034,122.206h8.883l-4.442-15.928Z",
    transform: "translate(3.5 -1.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_319-2",
    "data-name": "Caminho 319",
    d: "M181.8,145.013H163.117l-8.02-21h-5.315v21H132.928V90.106h28.68q9.491,0,14.742,4.445a14.61,14.61,0,0,1,5.249,11.725,17.625,17.625,0,0,1-1.931,8.387q-1.93,3.641-7.8,6.416ZM149.782,112.27h7.2a8.859,8.859,0,0,0,5.109-1.328,4.431,4.431,0,0,0,1.931-3.9q0-5.269-6.476-5.27h-7.763Z",
    transform: "translate(-9.19 -1.39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_320)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_320-2",
    "data-name": "Caminho 320",
    d: "M202.408,145.013V90.106h21.239q13.836,0,20.716,8.206a28.683,28.683,0,0,1,6.878,18.986q0,12.31-7.381,20.012t-19.167,7.7Zm16.854-12.631h4.385q4.182,0,7.06-4.062t2.875-11.062a20.043,20.043,0,0,0-2.554-10.338,8.1,8.1,0,0,0-7.381-4.345h-4.385Z",
    transform: "translate(-21.83 -1.39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_321-2",
    "data-name": "Caminho 321",
    d: "M338.652,90.106l-14.564,54.907H309.929l-7.681-30.29-7.254,30.29H280.232L265.643,90.106H281.5l7.68,31.6,7.493-31.6h13.232l8.151,31.665,7.692-31.665Z",
    transform: "translate(-33.34 -1.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_322-2",
    "data-name": "Caminho 322",
    d: "M383,145.67q-11.585,0-18.885-7.682t-7.3-20.556q0-12.309,6.98-20.333t19.368-8.025q11.464,0,18.685,7.562t7.22,20.193q0,13.074-7.281,20.957T383,145.67m-.08-12.469a6.372,6.372,0,0,0,6.134-3.72q1.87-3.72,1.87-13.616,0-14.32-7.683-14.321-8.286,0-8.286,16.331,0,15.326,7.964,15.326",
    transform: "translate(-49.93 -1.21)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_323-2",
    "data-name": "Caminho 323",
    d: "M478.261,145.013H459.577l-8.02-21h-5.315v21H429.388V90.106h28.68q9.491,0,14.742,4.445a14.61,14.61,0,0,1,5.249,11.725,17.626,17.626,0,0,1-1.931,8.387q-1.93,3.641-7.8,6.416ZM446.242,112.27h7.2a8.859,8.859,0,0,0,5.109-1.328,4.431,4.431,0,0,0,1.931-3.9q0-5.269-6.476-5.27h-7.763Z",
    transform: "translate(-63.13 -1.39)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2263.81, 723.31)",
    filter: "url(#Caminho_324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_324-2",
    "data-name": "Caminho 324",
    d: "M548.385,145.013H529.943l-9.492-20.75-5.694,8.079v12.671H498.868V90.106h15.889v22.7l15.142-22.7h15.148L531.18,110.2Z",
    transform: "translate(-75.77 -1.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4448",
    "data-name": "Grupo 4448",
    transform: "translate(2750.767 836.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_325",
    "data-name": "Caminho 325",
    d: "M588.029,141.87q0,5.621-5.554,5.635t-5.539-5.635V125.5q0-5.621,5.539-5.622t5.554,5.622v6.549h-3.861V125.5q0-1.8-1.678-1.814h-.028q-1.665,0-1.665,1.814V141.87q0,1.815,1.678,1.814t1.693-1.814v-4.353h3.861Z",
    transform: "translate(-576.937 -119.875)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_144",
    "data-name": "Ret\\xE2ngulo 144",
    width: 3.861,
    height: 26.771,
    transform: "translate(14.299 0.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_326",
    "data-name": "Caminho 326",
    d: "M611.621,139.371l4,7.792H611.39l-3.439-7.1h-.532v7.1h-3.861V120.392h5.622q5.144.015,5.144,5.635v8.405a5.067,5.067,0,0,1-2.7,4.939m-4.2-15.185v12.2h.887a3.7,3.7,0,0,0,1.105-.11,1.655,1.655,0,0,0,1.051-1.706v-8.555q0-1.827-1.679-1.827Z",
    transform: "translate(-581.781 -119.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_327",
    "data-name": "Caminho 327",
    d: "M631.9,141.964q0,5.621-5.554,5.635t-5.54-5.635V120.392h3.862v21.572q0,1.815,1.678,1.814t1.693-1.814V120.392H631.9Z",
    transform: "translate(-584.919 -119.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_328",
    "data-name": "Caminho 328",
    d: "M646.6,139.371l4,7.792h-4.23l-3.439-7.1H642.4v7.1h-3.862V120.392h5.622q5.145.015,5.144,5.635v8.405a5.066,5.066,0,0,1-2.7,4.939m-4.2-15.185v12.2h.887a3.7,3.7,0,0,0,1.105-.11,1.654,1.654,0,0,0,1.05-1.706v-8.555q0-1.827-1.679-1.827Z",
    transform: "translate(-588.145 -119.969)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_329",
    "data-name": "Caminho 329",
    d: "M666.706,141.87q0,5.621-5.554,5.635t-5.539-5.635V125.5q0-5.621,5.539-5.622t5.554,5.622v6.563h-3.861V125.5q0-1.8-1.678-1.814h-.028q-1.665,0-1.665,1.814V141.87q0,1.815,1.678,1.814t1.693-1.814v-1.9h-1.678v-3.82h5.539Z",
    transform: "translate(-591.253 -119.875)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_145",
    "data-name": "Ret\\xE2ngulo 145",
    width: 3.861,
    height: 26.771,
    transform: "translate(78.797 0.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_330",
    "data-name": "Caminho 330",
    d: "M685.485,141.705l-.7,5.458H680.9l3.985-26.771h5.294l3.971,26.771h-3.9l-.7-5.458Zm3.6-3.684-1.569-12.444-1.569,12.444Z",
    transform: "translate(-595.854 -119.969)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_331",
    "data-name": "Caminho 331",
    d: "M614.665,63.193,626.049,85.38H614l-9.792-20.206H602.7V85.38h-11V9.144h16.008q14.649.039,14.649,16.047V49.127q0,10.1-7.694,14.066M602.7,19.946V54.684h2.525a10.6,10.6,0,0,0,3.148-.311q2.992-1.2,2.992-4.858V25.153q0-5.206-4.779-5.207Z",
    transform: "translate(2171.144 736.649)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_332",
    "data-name": "Caminho 332",
    d: "M661.884,23.68q0-5.129-4.779-5.168h-.078q-4.741,0-4.741,5.168V33.9h-11V23.68q0-16.008,15.776-16.009,15.814,0,15.814,16.009V34.6q0,9.831-6.8,12.94,6.8,3.109,6.8,12.939v9.83q0,16.009-15.814,16.009-15.776,0-15.776-16.009V60.088h11V70.307q0,5.168,4.741,5.168h.078q4.779-.038,4.779-5.168v-9.83q0-7.654-6.955-7.654h-2.06V41.981h2.915q6.1,0,6.1-7.461Z",
    transform: "translate(2162.121 736.917)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensivoR3CirurgiaGeral);
export default __webpack_public_path__ + "static/media/extensivoR3CirurgiaGeral.d1726f39d80c76da67fdea794e13e483.svg";
export { ForwardRef as ReactComponent };